import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  messagingUrl: null,
  messagingUrlV2: null,
};

const messagingUrlSlice = createSlice({
  name: 'messagingUrl',
  initialState,
  reducers: {
    setMessagingUrl: (_, { payload }) => payload,
  },
});

export const { setMessagingUrl } = messagingUrlSlice.actions;

export default messagingUrlSlice.reducer;
